export default "__VITE_PUBLIC_ASSET__c51525fd__"